module.exports = __webpack_public_path__ + "img/4.b22b4181.svg";